import { Required } from "./Required";
import { Info } from "./Info";
import { useFormContext } from "react-hook-form";
import { motion } from "framer-motion";
import { MdError } from "react-icons/md";
import { findInputError, isFormInvalid } from "../utils";

export const RentFormInput = ({
  label,
  type,
  id,
  info,
  placeholder,
  validation,
  name,
  required,
  currency,
  onChange,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputError = findInputError(errors, name);
  const isInvalid = isFormInvalid(inputError);
  const registerProps = register(name, validation);
  const handleChange = (e) => {
    if (registerProps.onChange) {
      registerProps.onChange(e);
    }
    if (onChange) {
      onChange(e);
    }
  };

  // Prevent scrolling from changing the input value
  const preventWheelChange = (e) => {
    // Prevent the default scroll behavior when the input is focused
    if (document.activeElement === e.target) {
      e.preventDefault();
    }
  };

  return (
    <div className="mb-5 block w-full">
      <div className="md:flex md:items-center">
        <div className=" md:w-3/4  mb-2 md:mb-0 pr-0 md:pr-2 flex justify-between md:justify-start items-center">
          <div>
            <label id="rent-label" className="text-gray-700">{label}</label>
            {required ? <Required /> : null}
          </div>
          {info ? <Info infoId={`tooltip-${id}`} infoText={info} /> : null}
        </div>
        <div className="ml-auto md:ml-0 md:w-1/4">
          <div className="relative text-gray-700">
            <input
              type={type}
              id={id}
              name={id}
              className={
                "w-full pl-8 rounded border border-gray-800 bg-white p-3 shadow shadow-gray-100  appearance-none outline-none text-neutral-800 " +
                (isInvalid ? "border-red-500" : null)
              }
              placeholder={placeholder}
              step="0.01"
              onWheel={preventWheelChange}
              inputMode={type === "number" ? "decimal" : "text"}
              autoComplete="off"
              data-lpignore="true"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  // Find the next input field
                  const inputs = Array.from(document.querySelectorAll('input'));
                  const currentIndex = inputs.indexOf(e.target);
                  if (currentIndex < inputs.length - 1) {
                    inputs[currentIndex + 1].focus();
                  }
                }
              }}
              {...registerProps}
              onChange={handleChange}
            />
            {currency === "true" ? (
              <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
                $
              </div>
            ) : null}
          </div>
          {isInvalid && (
            <InputError
              message={inputError.error.message}
              key={inputError.error.message}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const InputError = ({ message }) => {
  return (
    <motion.p
      className="flex items-center gap-1 px-2 font-semibold text-xs text-red-500 rounded-md"
      {...framer_error}
    >
      <MdError />
      {message}
    </motion.p>
  );
};

const framer_error = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 10 },
  transition: { duration: 0.2 },
};
